// import directly from the the module to avoid circular dependencies
import { rateLimitMutatorRef } from "../Reference/rateLimitMutatorRef.js";
import { debounceAnimationFrame } from "./debounceAnimationFrame.js";
import { debounceMicrotask } from "./debounceMicrotask.js";
import { debounceTimeout } from "./debounceTimeout.js";
/**
 * Debounce a function to only run after a certain amount of time has passed
 * since the last time it was called. The timer resets every time the function
 * is called.
 *
 * @public
 */
export function debounce(fn, wait) {
    if (typeof wait === "number") {
        return debounceTimeout(fn, wait);
    }
    if (wait === debounce.Wait.AnimationFrame) {
        return debounceAnimationFrame(fn);
    }
    if (wait === debounce.Wait.Microtask) {
        return debounceMicrotask(fn);
    }
    throw new Error(`Invalid debounce type: ${wait}`);
}
(function (debounce) {
    let Wait;
    (function (Wait) {
        Wait["AnimationFrame"] = "animationFrame";
        Wait["Microtask"] = "microtask";
    })(Wait = debounce.Wait || (debounce.Wait = {}));
    /**
     * Debounce a reference to only update after a certain amount of time has passed
     * since the last time it was called. The timer resets every time the reference
     * is updated.
     *
     * @public
     */
    function reference(origin$, wait) {
        return rateLimitMutatorRef(origin$, (fn) => debounce(fn, wait));
    }
    debounce.reference = reference;
})(debounce || (debounce = {}));
